 export const Errors = {
    NONE: "NONE",
    NO_VEHICLE : "NO_VEHICLE",
    NO_VALID_VEHICLE : "NO_VALID_VEHICLE",
    NO_MOTOR : "NO_MOTOR",
    NO_CAR : "NO_CAR",
    NO_VALID_VEHICLE_TYPE : "NO_VALID_VEHICLE_TYPE",
    getMessage: function (error) {
      switch (error) {
        case this.NONE:
          return "None";
        case this.NO_CAR:
          return "No CAR";
        case this.NO_MOTOR:
          return "No MOTOR";
        case this.NO_VEHICLE:
          return "No Vehicle";
        case this.NO_VALID_VEHICLE:
          return "No Valid Vehicle";
        case this.NO_VALID_VEHICLE_TYPE:
          return "No Valid Vehicle Type";
        default:
          return "Unknown error";
      }
    },
  };